"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _propTypes = require("prop-types");
var _theme = _interopRequireDefault(require("../../Theme/lib/AirasiaClassic/theme"));
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
const FlatbedSelected = props => {
  const {
    text,
    fontsize,
    ...rest
  } = props;
  const theme = _react.default.useContext(_styledComponents.ThemeContext);
  const {
    sizeStyles: {
      height
    }
  } = (0, _inline_svg.parseStyles)({
    fontsize
  }, theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    height: height,
    viewBox: "0 0 39 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,

    d: "M0.5 30H2.5C3.60457 30 4.5 30.8954 4.5 32V54L34.5 54V32C34.5 30.8954 35.3954 30 36.5 30C37.6046 30 38.5 30.8954 38.5 32V54V56C38.5 57.1046 37.6046 58 36.5 58L0.5 58V56V54V30Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,

    d: "M0 30H2C3.10457 30 4 30.8954 4 32V54L34 54V32C34 30.8954 34.8954 30 36 30C37.1046 30 38 30.8954 38 32V54V56C38 57.1046 37.1046 58 36 58L0 58V56V54V30Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,

    d: "M6 2V8V9V38V39V48C6 50.2091 7.79086 52 10 52H28C30.2091 52 32 50.2091 32 48V39V38V9V8V2C32 0.89543 31.1046 0 30 0H8C6.89543 0 6 0.895432 6 2Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,

    d: "M6 2V8V9V38V39V48C6 50.2091 7.79086 52 10 52H28C30.2091 52 32 50.2091 32 48V39V38V9V8V2C32 0.89543 31.1046 0 30 0H8C6.89543 0 6 0.895432 6 2Z",
    fill: _theme.default.colors.default
  }), /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M7 8V2H5V8H7ZM5 8V9H7V8H5ZM5 9V38H7V9H5ZM5 38V39H7V38H5ZM5 39V48H7V39H5ZM5 48C5 50.7614 7.23858 53 10 53V51C8.34315 51 7 49.6569 7 48H5ZM10 53H28V51H10V53ZM28 53C30.7614 53 33 50.7614 33 48H31C31 49.6569 29.6569 51 28 51V53ZM33 48V39H31V48H33ZM33 39V38H31V39H33ZM33 38V9H31V38H33ZM33 9V8H31V9H33ZM31 2V8H33V2H31ZM30 1C30.5523 1 31 1.44771 31 2H33C33 0.343146 31.6569 -1 30 -1V1ZM8 1H30V-1H8V1ZM7 2C7 1.44772 7.44772 1 8 1V-1C6.34315 -1 5 0.343148 5 2H7Z",
    fill: _theme.default.colors.secondary,
    mask: "url(#path-2-inside-1)"
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: "50%",
    y: "50%",
    fill: _theme.default.colors.secondary,
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: _theme.default.fontFamily.default,
    "aria-label": "Passenger name"
  }, text)));
};
FlatbedSelected.propTypes = {
  text: _propTypes.string.isRequired,
  ..._inline_svg2.default.propTypes
};
FlatbedSelected.defaultProps = _inline_svg2.default.defaultProps;
var _default = exports.default = FlatbedSelected;